<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="productProjectForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <piqet-angular-common-input
              label="Product name"
              name="productName"
              placeholder="Product name"
              formControlName="productName"
              [control]="productProjectForm.controls['productName']"
              [submitted]="submitted"
              [maxLength]="50"
              (customBlur)="getProductname($any(productProjectForm.get('productName')?.value))"
            ></piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              label="Product name used in report"
              name="productNameReport"
              placeholder="Product name"
              formControlName="productNameReport"
              [control]="productProjectForm.controls['productNameReport']"
              [submitted]="submitted"
              [maxLength]="15"
            ></piqet-angular-common-input>
          </div>
        </div>
        <div class="col-md-6">
          <label *ngIf="productProjectForm.get('country')?.value" class="sub-header-drpdown"
            >Country *</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            class="personalInputFiled"
            #select
            [items]="countryList"
            [searchable]="false"
            formControlName="country"
            bindLabel="name"
            [searchFn]="commonInputSearch"
            placeholder="Country*"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="select.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              (submitted || productProjectForm.controls['country'].touched) &&
              productProjectForm.controls['country'].errors
            "
          >
            <div
              *ngIf="productProjectForm.controls['country'].errors?.['required']"
              class="input-error"
            >
              Country is required.
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col-sm-4">
          <div class="d-flex w-100 justify-content-between align-items-center checkboxview">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isCostTurnedOff"
                  (change)="costTurnOff($event)"
                />
              </div>
              <div><span class="checkbox-style switch-cost">Switch on cost</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3" *ngIf="showCurrencyList">
        <div class="col-sm-6 currencyTab">
          <div class="project-spacing currency-drpdown">
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #currency
              [items]="currencyList"
              (change)="selectCurrency($event)"
              [searchable]="false"
              bindLabel="name"
              formControlName="currency"
              [searchFn]="commonInputSearch"
              placeholder="Currency"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="currency.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <piqet-angular-file-upload
            type="image"
            [customConfig]="{
              selectButtonText: 'Select file',
              changeButtonText: 'Change',
              removeButtonText: 'Remove',
              placeholderText: 'Project image',
              acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
              acceptAttribute: '.png,.jpg,.jpeg,.gif',
              maxFileSize: 5,
              showPreview: false,
              customErrorMessage: 'Only .jpg,.png,.jpeg,.gif file allowed'
            }"
            [existingFileUrl]="existingImageUrl"
            [existingFileName]="existingFileName"
            (fileSelected)="onFileSelected($event)"
            (removeConfirmation)="onRemoveImage()"
            #fileUploadComponent
            customClass="form-group"
          >
          </piqet-angular-file-upload>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group required">
            <piqet-angular-common-input
              label="Quantity"
              name="amount"
              placeholder="Quantity"
              formControlName="amount"
              [control]="productProjectForm.controls['amount']"
              [submitted]="submitted"
              [maxLength]="50"
              inputType="number"
              [required]="true"
              [preventNegative]="true"
              [errorMessages]="{
                nonNegative: 'Please enter a positive value.'
              }"
            ></piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <piqet-angular-common-input
              label="Density (kg/L)"
              name="density"
              placeholder="Density (kg/L)"
              formControlName="density"
              [control]="productProjectForm.controls['density']"
              [submitted]="submitted"
              [maxLength]="50"
              inputType="number"
              [preventNegative]="true"
              [errorMessages]="{
                greaterThanZero: 'Density must be greater than 0.'
              }"
            ></piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="input-div">
            <label *ngIf="productProjectForm.get('unit')?.value" class="sub-header-drpdown"
              >Unit *</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #unit
              [items]="unitList"
              formControlName="unit"
              [searchable]="false"
              bindLabel="name"
              placeholder="Unit *"
              (change)="changeUnit($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="unit.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div
            *ngIf="
              (submitted || productProjectForm.controls['unit']?.touched) &&
              productProjectForm.controls['unit']?.invalid
            "
            class="input-error"
          >
            Unit is required.
          </div>
        </div>
        <div class="form-group">
          <div class="services-form">
            <textarea
              formControlName="description"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Description"
            ></textarea>
            <label>Description</label>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
